import React from "react";
import Nav from "../../component/Nav";
import { FaCrown } from "react-icons/fa";
import {
  IoIosContact,
  IoIosArrowForward,
  IoIosLock,
  IoIosTrendingUp,
  IoIosDocument,
  IoIosTime,
  IoIosPeople,
  IoIosCash,
  IoIosPricetags,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosShareAlt,
  IoLogoWhatsapp,
} from "react-icons/io";
import { GrEdit } from "react-icons/gr";
import { AuthContext } from "../../auth/ZAuth";
import { FormatNumber } from "../../helpers";
import { useCompany } from "../../api";
import AccountLoader from "../../loader/AccountLoader";
import "./account.css";

const Section = ({ title, children }) => (
  <div className="acc-section">
    {title && <div className="acc-section__title">{title}</div>}
    <div className="acc-section__body">{children}</div>
  </div>
);

const Row = ({ icon: Icon, label, onClick, danger }) => (
  <div className="acc-row" onClick={onClick}>
    <span className="acc-row__icon">
      <Icon />
    </span>
    <span
      className={`acc-row__label ${danger ? "acc-row__label--danger" : ""}`}
    >
      {label}
    </span>
    <IoIosArrowForward className="acc-row__chevron" />
  </div>
);

export default function Account(props) {
  const { data: company } = useCompany();
  const { user, logout } = React.useContext(AuthContext);

  if (!company) {
    return (
      <>
        <Nav title="Akun" icon={IoIosContact} />
        <AccountLoader />
      </>
    );
  }

  // Admin flag now comes from the backend (Config::is_admin via /company)
  // so it works across providers — federated and email/password sign-in
  // both resolve to the same company.id, which is matched against
  // ADMIN_USER_IDS env on the server.
  const isAdmin = !!company.isAdmin;
  // Display name: prefer the stored company.name (single source of truth
  // after the email-identity refactor), then JWT name, then Cognito's
  // raw username (e.g. "google_xxx") as a last resort.
  const displayName = company.name || user.name || user.username;
  const go = (path) => () => props.history.push(path);

  return (
    <>
      <Nav title="Akun" icon={IoIosContact} />
      <div className="main-padding">
        <div className="acc-profile-card">
          <div className="acc-profile-card__avatar">
            {company.level === 0 ? (
              <IoIosContact size="2.8em" />
            ) : (
              <FaCrown size="2.2em" />
            )}
          </div>
          <div className="acc-profile-card__info">
            <div className="acc-profile-card__name">{displayName}</div>
            <div className="acc-profile-card__email">{user.email}</div>
            <span
              className={`acc-profile-card__badge ${
                company.level === 0
                  ? "acc-profile-card__badge--free"
                  : "acc-profile-card__badge--premium"
              }`}
            >
              {company.level === 0 ? "Free Account" : "Premium Account"}
            </span>
          </div>
          <button
            type="button"
            className="acc-profile-card__edit"
            onClick={go("/account/edit-profile")}
            aria-label="Edit profil"
          >
            <GrEdit size="1.1em" />
          </button>
        </div>

        <div
          className="acc-credit-card"
          onClick={go("/topup")}
          style={{ cursor: "pointer" }}
        >
          <div className="acc-credit-card__label">Credit Anda</div>
          <div
            className={`acc-credit-card__amount ${
              company.credit < 0 ? "acc-credit-card__amount--negative" : ""
            }`}
          >
            {FormatNumber(company.credit)}
          </div>
          <div className="acc-credit-card__hint">Tap untuk top up</div>
        </div>

        <Section title="Profil">
          <Row
            icon={GrEdit}
            label="Edit profil"
            onClick={go("/account/edit-profile")}
          />
          <Row
            icon={IoIosLock}
            label="Ubah password"
            onClick={go("/account/change-password")}
          />
        </Section>

        <Section title="Premium & Saldo">
          {company.level === 0 && (
            <Row
              icon={FaCrown}
              label="Upgrade akun"
              onClick={go("/upgrade-account")}
            />
          )}
          <Row
            icon={IoIosTrendingUp}
            label="Top up credit"
            onClick={go("/topup")}
          />
          <Row
            icon={IoIosTime}
            label="Riwayat credit"
            onClick={go("/credits")}
          />
          <Row icon={IoIosDocument} label="Invoice" onClick={go("/invoices")} />
        </Section>

        <Section title="Catatan Lain">
          <Row icon={IoIosCash} label="Uang tunai" onClick={go("/cash")} />
          <Row
            icon={IoIosPricetags}
            label="Kelola tag"
            onClick={go("/tags")}
          />
        </Section>

        <Section title="Berbagi">
          <Row
            icon={IoIosShareAlt}
            label="Berbagi ke organisasi"
            onClick={go("/account/share")}
          />
        </Section>

        {isAdmin && (
          <Section title="Admin">
            <Row
              icon={IoIosPeople}
              label="Kelola users"
              onClick={go("/users")}
            />
          </Section>
        )}

        <Section title="Bantuan">
          <Row
            icon={IoLogoWhatsapp}
            label="Kontak developer"
            onClick={() => window.open("https://wa.me/6285776556212", "_blank")}
          />
          <Row
            icon={IoIosInformationCircleOutline}
            label="Tentang Cashflow"
            onClick={go("/about")}
          />
        </Section>

        <Section>
          <Row icon={IoIosLogOut} label="Keluar" onClick={logout} danger />
        </Section>

        <div className="acc-footer">Cashflow</div>
      </div>
    </>
  );
}
